import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { AmbassadorProgramCompanyVehicleScheduleDTO } from '../models/ambassador-program-company-vehicle-schedule-dto';

@Injectable({
  providedIn: 'root'
})
export class AmbassadorProgramCompanyVehicleScheduleService {

  private pathAPI = environment.urlAPI;
  private controller = "AmbassadorProgramCompanyVehicleSchedule/";

  constructor(private http: HttpClient) { }

  public get(id: string): Observable<AmbassadorProgramCompanyVehicleScheduleDTO> {
    return this.http.get<AmbassadorProgramCompanyVehicleScheduleDTO>(this.pathAPI + this.controller + id);
  }

  public getAllByVehicle(idVehicle: string): Observable<AmbassadorProgramCompanyVehicleScheduleDTO[]> {
    return this.http.get<AmbassadorProgramCompanyVehicleScheduleDTO[]>(this.pathAPI + this.controller + 'GetByVehicle/' + idVehicle);
  }

  public post(data: AmbassadorProgramCompanyVehicleScheduleDTO): Observable<any> {
    return this.http.post<any>(this.pathAPI + this.controller, data);
  }

  public delete(id: string): Observable<any> {
    return this.http.delete<any>(this.pathAPI + this.controller + id);
  }
}

